// The presenter's copy of aha-elearning's conversionCardView (features/courseConversion/conversionRun.ts)
// for a run the master agent owns, so the app-wide card reads exactly like the one the course editor shows.

export const COURSE_CONVERSION_STAGES = ['reading', 'planning', 'building', 'finished', 'failed', 'cancelled']

export const TERMINAL_COURSE_CONVERSION_STAGES = ['finished', 'failed', 'cancelled']

export const isCourseConversionRunning = (stage) => (
  COURSE_CONVERSION_STAGES.includes(stage) && !TERMINAL_COURSE_CONVERSION_STAGES.includes(stage)
)

const READING_VALUE = 2
const PLANNING_VALUE = 6

/**
 * What the <aha-background-task> card shows for one conversion.
 *
 * @param {{ stage: string, courseTitle?: string }} card
 * @param {{ online: boolean, translate: (key: string) => string }} options
 * @returns {{ state: string, heading: string, description: string, value: number|null, caption: string }}
 *   `value` null = the bar eases on its own (`no-percentage`).
 */
export function courseConversionCardView(card, { online, translate }) {
  if (card.stage === 'finished') {
    return {
      state: 'success',
      heading: card.courseTitle || translate('Your course'),
      // <aha-background-task> renders its `link` slot inside the description line, so an empty one hides "Open course".
      description: translate('Course ready'),
      value: null,
      caption: '',
    }
  }
  if (card.stage === 'cancelled') {
    return {
      state: 'canceled',
      heading: translate('Conversion cancelled'),
      description: translate('What was built is saved as a draft.'),
      value: null,
      caption: '',
    }
  }
  if (card.stage === 'failed') {
    return {
      state: 'error',
      heading: translate('Conversion failed'),
      description: translate('We couldn’t turn this presentation into a course. Try again.'),
      value: null,
      caption: '',
    }
  }
  const bar = {
    reading: { value: READING_VALUE, caption: translate('Reading your slides…') },
    planning: { value: PLANNING_VALUE, caption: translate('Planning lessons…') },
  }[card.stage] || { value: null, caption: translate('Writing lessons…') }
  if (!online) {
    return {
      state: 'offline',
      heading: translate('Connection lost'),
      description: translate('Waiting to reconnect…'),
      value: bar.value,
      caption: '',
    }
  }
  return {
    state: 'progress',
    heading: card.courseTitle || translate('Your course'),
    description: '',
    value: bar.value,
    caption: bar.caption,
  }
}
